module.exports = __webpack_public_path__ + "img/bonus.b7c5af27.png";